const AppRoutes = {
  Root: '/',
  Login: '/login',

  ProjectsNew: '/projects/new',
  ProjectsClone: (projectId: string) => `/projects/new/${projectId}`,
  ProjectsView: (projectId: string) => `/projects/${projectId}`,
  ProjectsViewWildcard: '/projects/:projectId/*',
  Project: (projectId: string) => `/projects/${projectId}/project`,

  Checkout: (projectId: string) => `/projects/${projectId}/checkout`,
  CheckoutGeneral: (projectId: string) =>
    `/projects/${projectId}/checkout/general`,
  CheckoutPaymentConfiguration: (projectId: string) =>
    `/projects/${projectId}/checkout/paymentConfiguration`,
  CheckoutFlows: (projectId: string) => `/projects/${projectId}/checkout/flows`,
  CheckoutVpos: (projectId: string) => `/projects/${projectId}/checkout/vpos`,
  CheckoutControlConfig: (projectId: string) =>
    `/projects/${projectId}/checkout/controlConfig`,
  CheckoutTseConfiguration: (projectId: string) =>
    `/projects/${projectId}/checkout/tseConfiguration`,
  CheckoutDiscountReasons: (projectId: string) =>
    `/projects/${projectId}/checkout/discountReasons`,
  CheckoutTaxCategories: (projectId: string) =>
    `/projects/${projectId}/checkout/taxCategories`,
  CheckoutCheckConfig: (projectId: string) =>
    `/projects/${projectId}/checkout/checkConfig`,
  CheckoutCustomerPropertiesLookup: (projectId: string) =>
    `/projects/${projectId}/checkout/customerPropertiesLookup`,
  CheckoutFulfillmentConfig: (projectId: string) =>
    `/projects/${projectId}/checkout/fulfillmentConfig`,
  CheckoutCustomerValidation: (projectId: string) =>
    `/projects/${projectId}/checkout/customerValidation`,
  CheckoutVoucherProviders: (projectId: string) =>
    `/projects/${projectId}/checkout/voucherProviders`,
  CheckoutDepositReturnVoucherProviders: (projectId: string) =>
    `/projects/${projectId}/checkout/depositReturnVoucherProviders`,
  CheckoutServiceCredentials: (projectId: string) =>
    `/projects/${projectId}/checkout/serviceCredentials`,
  CheckoutCouponConfiguration: (projectId: string) =>
    `/projects/${projectId}/checkout/couponConfiguration`,
  CheckoutSets: (projectId: string) => `/projects/${projectId}/checkout/sets`,
  CheckoutReturn: (projectId: string) =>
    `/projects/${projectId}/checkout/return`,
  CheckoutOverrideTemplates: (projectId: string) =>
    `/projects/${projectId}/checkout/overrideTemplates`,
  CheckoutCash: (projectId: string) => `/projects/${projectId}/checkout/cash`,

  Transaction: (projectId: string) => `/projects/${projectId}/transaction`,
  TransactionTransactions: (projectId: string) =>
    `/projects/${projectId}/transaction/transactions`,
  TransactionReporting: (projectId: string) =>
    `/projects/${projectId}/transaction/reporting`,
  TransactionCleanupSchedule: (projectId: string) =>
    `/projects/${projectId}/transaction/cleanup-schedule`,
  TransactionClosingLogSink: (projectId: string) =>
    `/projects/${projectId}/transaction/closing-log-sink`,

  CheckoutDevices: (projectId: string) =>
    `/projects/${projectId}/checkout-devices`,
  CheckoutDevicesAvailableTypes: (projectId: string) =>
    `/projects/${projectId}/checkout-devices/available-types`,
  CheckoutDevicesDynaConfig: (projectId: string) =>
    `/projects/${projectId}/checkout-devices/dyna-config`,

  Sidebar: (projectId: string) => `/projects/${projectId}/sidebar`,
  Export: (projectId: string) => `/projects/${projectId}/export`,
  ExportThirdParty: (projectId: string) =>
    `/projects/${projectId}/export/third-party`,
  ExportTransactionsStatistics: (projectId: string) =>
    `/projects/${projectId}/export/transactions-statistics`,

  Realms: '/realms',
  RealmsNew: '/realms/new',
  RealmsClone: (realmID: string) => `/realms/new/${realmID}`,
  RealmsView: (realmID: string) => `/realms/${realmID}`,

  CortexDecoderKeys: '/cortex-decoder-keys',
  CortexDecoderKeysNew: '/cortex-decoder-keys/new',
  CortexDecoderKeysView: (keyID: string) => `/cortex-decoder-keys/${keyID}`,
  CortexDecoderKeysEdit: (keyID: string) =>
    `/cortex-decoder-keys/${keyID}/edit`,

  Apps: '/apps',
  AppsNew: '/apps/new',
  AppsView: (appID: string) => `/apps/${appID}`,
  AppsEdit: (appID: string) => `/apps/${appID}/edit`,

  Organizations: '/organizations',
  OrganizationsNew: '/organizations/new',
  OrganizationsView: (organizationID: string) =>
    `/organizations/${organizationID}`,
  OrganizationsEdit: (organizationID: string) =>
    `/organizations/${organizationID}/edit`,

  Tools: (id: string) => `/tools/${id}`,
  ToolsDynaformPreview: '/tools/dynaform-preview',
};

export default AppRoutes;
